'use client';

import { animate, motion, useInView, useMotionValue, useTransform } from 'motion/react';
import { useEffect, useRef } from 'react';

type CounterProps = {
  from: number;
  to: number;
  duration: number;
};

export const Counter = ({ from, to, duration }: CounterProps) => {
  const ref = useRef(null);
  const inView = useInView(ref);

  const count = useMotionValue(from);
  const rounded = useTransform(count, latest => Math.round(latest));

  useEffect(() => {
    if (inView) {
      animate(count, to, { duration });
    }
  }, [count, duration, inView, to]);

  return <motion.span ref={ref}>{rounded}</motion.span>;
};
